/**
 * 学习者词表（旧 views/user/components/VocabularyListTab.vue）：
 * 按后端熟悉度分值降序分页显示，点击单词打开该词的证据抽屉
 */
import { Button, Table, type TableColumnsType } from 'antd'
import dayjs from 'dayjs'
import type { VocabularyWord } from '@/api/services/admin'
import { WordEvidenceDrawer } from './WordEvidenceDrawer'
import styles from './UserVocabularyPage.module.css'

interface VocabularyListTabProps {
  userId: number
  words: VocabularyWord[]
  total: number
  loading: boolean
  page: number
  pageSize: number
  selectedWord: VocabularyWord | null
  onSelectWord: (word: VocabularyWord | null) => void
  onPageChange: (page: number, pageSize: number) => void
  onRefresh: () => void
}

export function VocabularyListTab({
  userId,
  words,
  total,
  loading,
  page,
  pageSize,
  selectedWord,
  onSelectWord,
  onPageChange,
  onRefresh
}: Readonly<VocabularyListTabProps>) {
  const columns: TableColumnsType<VocabularyWord> = [
    {
      title: '词汇（点击查看证据）',
      dataIndex: 'word',
      render: (_, record) => (
        <Button type="link" onClick={() => onSelectWord(record)}>
          {record.word}
        </Button>
      )
    },
    { title: '熟悉度分值', dataIndex: 'familiarity' },
    {
      title: '分值更新时间',
      dataIndex: 'updated_at',
      render: (value: string) => dayjs(value).format('YYYY-MM-DD HH:mm:ss')
    }
  ]

  return (
    <div>
      <div className={styles.toolbar}>
        <span>按熟悉度分值从高到低排列</span>
        <Button loading={loading} onClick={onRefresh}>
          刷新
        </Button>
      </div>

      <Table<VocabularyWord>
        rowKey="lexeme_id"
        columns={columns}
        dataSource={words}
        loading={loading}
        pagination={{
          current: page,
          pageSize,
          total,
          showSizeChanger: true,
          showTotal: (count) => `共 ${count} 个词汇`
        }}
        onChange={(pagination) => onPageChange(pagination.current ?? 1, pagination.pageSize ?? pageSize)}
      />

      {selectedWord && (
        <WordEvidenceDrawer
          key={`${userId}-${selectedWord.lexeme_id}`}
          userId={userId}
          lexemeId={selectedWord.lexeme_id}
          onClose={() => onSelectWord(null)}
        />
      )}
    </div>
  )
}
